/* Sabores · Teaser (sections/sabores-teaser.liquid): wechselt die Sorte automatisch, Hover/Fokus/Tipp wählt.
   Touch: erster Tipp auf eine Tube wählt sie, zweiter öffnet das Produkt. Außerhalb des Bildschirms pausiert alles. */
(() => {
  if (customElements.get('sabores-teaser')) return;

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');

  class SaboresTeaser extends HTMLElement {
    connectedCallback() {
      this.tubes = [...this.querySelectorAll('[data-tube]')];
      if (this.tubes.length < 2) return;
      this.word = this.querySelector('[data-word]');
      this.pick = this.querySelector('[data-pick]');
      this.pickName = this.querySelector('[data-pick-name]');
      this.pickPrice = this.querySelector('[data-pick-price]');
      this.interval = Number(this.dataset.interval) || 2500;
      this.index = Math.max(0, this.tubes.findIndex((t) => t.classList.contains('is-active')));
      this.visible = false;
      this.hold = false;

      this.tubes.forEach((tube, i) => {
        tube.addEventListener('pointerenter', (e) => {
          if (e.pointerType === 'mouse') this.select(i);
        });
        tube.addEventListener('focus', () => {
          if (!tube.matches(':focus-visible')) return; // nur Tastatur, sonst öffnet der erste Tipp schon das Produkt
          this.hold = true;
          this.restart();
          this.select(i);
        });
        tube.addEventListener('blur', () => { this.hold = false; this.restart(); });
        tube.addEventListener('click', (e) => {
          if (finePointer.matches || i === this.index) return;
          e.preventDefault();
          this.select(i);
          this.restart();
        });
      });
      // Maus über dem Tuben-Bereich: automatischer Wechsel steht, bis sie ihn wieder verlässt
      const stage = this.querySelector('[data-stage]');
      stage.addEventListener('pointerenter', (e) => {
        if (e.pointerType !== 'mouse') return;
        this.hold = true;
        this.restart();
      });
      stage.addEventListener('pointerleave', (e) => {
        if (e.pointerType !== 'mouse') return;
        this.hold = false;
        this.restart();
      });

      this.observer = new IntersectionObserver(([entry]) => {
        this.visible = entry.isIntersecting;
        this.classList.toggle('is-paused', !this.visible);
        this.restart();
      }, { threshold: 0.2 });
      this.observer.observe(this);

      this.onVisibility = () => this.restart();
      document.addEventListener('visibilitychange', this.onVisibility);

      this.addEventListener('shopify:block:select', (e) => {
        const i = this.tubes.findIndex((t) => t.contains(e.target) || t === e.target);
        if (i < 0) return;
        this.hold = true;
        this.restart();
        this.select(i);
      });
      this.addEventListener('shopify:block:deselect', () => { this.hold = false; this.restart(); });
    }

    disconnectedCallback() {
      clearInterval(this.timer);
      this.observer?.disconnect();
      document.removeEventListener('visibilitychange', this.onVisibility);
    }

    restart() {
      clearInterval(this.timer);
      if (this.hold || !this.visible || document.hidden || reduceMotion.matches) return;
      this.timer = setInterval(() => this.select((this.index + 1) % this.tubes.length), this.interval);
    }

    select(i) {
      if (i === this.index) return;
      const prev = this.tubes[this.index];
      const tube = this.tubes[i];
      this.index = i;
      prev.classList.remove('is-active');
      tube.classList.add('is-active');

      const d = tube.dataset;
      this.style.setProperty('--sbt-act', d.bg);
      this.style.setProperty('--sbt-btn', d.btn);
      this.style.setProperty('--sbt-btn-ink', d.btnInk);
      this.pick.href = tube.href;
      this.pickName.textContent = d.name;
      this.pickPrice.textContent = d.price;

      if (reduceMotion.matches) {
        this.word.textContent = d.word;
        return;
      }
      const ease = 'cubic-bezier(.2,.8,.2,1)';
      this.word.animate([{ transform: 'translateY(0)', opacity: 1 }, { transform: 'translateY(-110%)', opacity: 0 }], { duration: 160, easing: 'ease-in' }).onfinish = () => {
        this.word.textContent = d.word;
        this.word.animate([{ transform: 'translateY(110%) rotate(-4deg)', opacity: 0 }, { transform: 'none', opacity: 1 }], { duration: 300, easing: ease });
      };
      tube.querySelector('.sbt__hop')?.animate(
        [{ transform: 'none' }, { transform: 'translateY(-16px) rotate(-5deg)' }, { transform: 'translateY(2px) rotate(2deg)' }, { transform: 'none' }],
        { duration: 520, easing: ease }
      );
      this.pick.animate([{ transform: 'scale(.94)' }, { transform: 'none' }], { duration: 260, easing: ease });
    }
  }

  customElements.define('sabores-teaser', SaboresTeaser);
})();
